import styled from 'styled-components';

export const StarsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 53px;
  //margin-bottom: 48px;

  @media ${(props) => props.theme.device.tablet} {
    margin-bottom: 60px;
    gap: 40px;

    > :not(:first-child, :last-child) .star-text {
      display: none;
    }

    .star-text {
      position: absolute;
      right: calc((100px - 25px) / 2 * -1); //? star-width - text-width
      left: calc((100px - 25px) / 2 * -1); //? star-width - text-width
    }
  }
`;

export const Star = styled.button`
  position: relative;
  text-align: center;
  width: 100px;
  cursor: pointer;
  align-self: flex-start;

  svg {
    margin-bottom: 14px;
  }

  &.active svg {
    fill: ${(props) => props.theme.colors.link} !important;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: -2px;
    border-radius: 4px;
  }

  @media ${(props) => props.theme.device.tablet} {
    width: auto;
  }
`;

export const AnswerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding-left: 30px;
  margin-bottom: 48px;
  font-family: ${({ theme }) => theme.fontset.titillium};
`;

//? the sole purpose of this is to make it possible
//? to use "as" to dynamically render a div or fieldset
export const QuestionWrapper = styled.div``;

export const Textarea = styled.textarea`
  min-height: 116px;
  padding: 8px;
  width: 100%;
`;

export const Legend = styled.div`
  margin-top: -8px;
  margin-bottom: 8px;
  color: ${(props) => props.theme.colors.fail};
`;
